"use client";

import { Text } from "@astryxdesign/core/Text";
import { VStack } from "@astryxdesign/core/VStack";
import { BRANDBOOK } from "@/lib/brand/brandbook";
import {
  LANDING_BG_COLOR_PRESETS,
  normalizeBackgroundColor,
} from "@/lib/landing/puck/styled-text";

type LandingBackgroundColorFieldProps = {
  value: string;
  onChange: (value: string) => void;
  label?: string;
};

export function LandingBackgroundColorField({
  value,
  onChange,
  label = "Цвет фона",
}: LandingBackgroundColorFieldProps) {
  const color = normalizeBackgroundColor(value);
  const pickerValue = color.startsWith("#") && color.length === 7 ? color : "#ffffff";

  return (
    <VStack gap={2} align="start" width="100%">
      <Text size="sm">{label}</Text>
      <div className="flex flex-wrap items-center gap-2">
        <input
          type="color"
          value={pickerValue}
          aria-label={label}
          className="h-8 w-10 cursor-pointer rounded-md border border-border bg-canvas p-0.5"
          onChange={(e) => onChange(e.target.value)}
        />
        <input
          type="text"
          value={typeof value === "string" ? value : ""}
          placeholder="#FFFFFF или пусто"
          className="min-w-0 flex-1 rounded-md border border-border bg-canvas px-2 py-1 text-sm text-primary"
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      <div className="flex flex-wrap gap-1.5">
        {LANDING_BG_COLOR_PRESETS.map((preset) => {
          const active =
            (preset.value === "" && !color) ||
            preset.value.toLowerCase() === color.toLowerCase();
          return (
            <button
              key={preset.label}
              type="button"
              title={preset.label}
              aria-label={preset.label}
              aria-pressed={active}
              onClick={() => onChange(preset.value)}
              className={[
                "h-7 min-w-7 rounded-md border px-1.5 text-[11px] leading-none",
                active ? "border-accent ring-1 ring-accent" : "border-border",
              ].join(" ")}
              style={{
                backgroundColor: preset.value || "transparent",
                color:
                  preset.value === BRANDBOOK.ink || preset.value === BRANDBOOK.rose
                    ? "#fff"
                    : BRANDBOOK.text,
              }}
            >
              {preset.value ? "" : "—"}
            </button>
          );
        })}
      </div>
    </VStack>
  );
}
